import { jsx as _jsx } from "react/jsx-runtime";
import "@amzn/awsui-global-styles/polaris.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import { client } from "./common/api/client";
import { TEMP_CREDS_SET_EVENT } from "./common/constants";
const cookieString = 'path=/; Secure; SameSite=Strict';
export const E2E_TEST_ENV_KEY = 'e2eTestEnvironment';
window.loadTemporaryCredentials = (stringifiedCredentials) => {
    const credentials = JSON.parse(stringifiedCredentials);
    document.cookie = `${credentials.accessTokenKey}=${credentials.accessTokenValue}; ${cookieString}`;
    document.cookie = `${credentials.idTokenKey}=${credentials.idTokenValue}; ${cookieString}`;
    document.cookie = `${credentials.lastAuthKey}=${credentials.lastAuthValue}; ${cookieString}`;
    document.cookie = `${E2E_TEST_ENV_KEY}=true; ${cookieString}`;
    window.dispatchEvent(new Event(TEMP_CREDS_SET_EVENT));
};
const root = createRoot(document.getElementById("root"));
root.render(_jsx(BrowserRouter, { children: _jsx(ApolloProvider, { client: client, children: _jsx(App, {}) }) }));
